import { gql } from "@apollo/client";

export const FIND_ALL_RECOVERY_PLANS_BY_PLAN = gql`
  query FindAllRecoveryPlansByPlan($uuid: ID!) {
    findAllRecoveryPlansByPlan(uuid: $uuid) {
      applicationName
      drPlanInPlace
      email
      hostingLocation
      phone
      planOwnerfirstName
      planOwnerlastName
      recoverySLA
      uuid
    }
  }
`;

export const CREATE_RECOVERY_PLAN = gql`
  mutation RecoveryPlan($data: CreateRecoveryPlanInput!) {
    createRecoveryPlan(data: $data) {
      applicationName
      drPlanInPlace
      email
      hostingLocation
      phone
      planOwnerfirstName
      planOwnerlastName
      recoverySLA
      uuid
    }
  }
`;

export const UPDATE_RECOVERY_PLAN = gql`
  mutation RecoveryPlan($data: UpdateRecoveryPlanInput!) {
    updateRecoveryPlan(data: $data) {
      applicationName
      drPlanInPlace
      email
      hostingLocation
      phone
      planOwnerfirstName
      planOwnerlastName
      recoverySLA
      uuid
    }
  }
`;

export const DELETE_RECOVERY_PLAN = gql`
  mutation DeleteRecoveryPlan($uuid: ID!) {
    deleteRecoveryPlan(uuid: $uuid) {
      applicationName
      drPlanInPlace
      email
      hostingLocation
      phone
      planOwnerfirstName
      planOwnerlastName
      recoverySLA
      uuid
    }
  }
`;
